<template>
	<div class="dashboard-container">
		<main class="main-content">
			<aside class="right-panel">
				<!-- 事件趋势图 -->
				<section class="panel-section breath-panel  h1 marquee-box marquee-panel">
					<div class="section-header">
						<div class="chart-tabs">
							<span :class="{tab:true,active:item.key == dateKey}" @click="dateClick(item.key)"
								v-for="(item,index) in dateData" :key="index">{{item.label}}</span>
						</div>
						<div class="legend">
							<span class="legend-item"><span class="dot red"></span>紧急</span>
							<span class="legend-item"><span class="dot yellow"></span>重要</span>
							<span class="legend-item"><span class="dot orange"></span>关注</span>
						</div>
					</div>
					<div class="echarts-trend" ref="trendChart"></div>
				</section>
				<!-- 重点告警 / 人员进出记录 -->
				<section class="panel-section breath-panel  h2 marquee-box marquee-panel">
					<div class="section-header">
						<div class="chart-tabs">
							<span :class="{tab:true, active: alarmTab == 'alarm'}" @click="switchAlarmTab('alarm')">重点告警</span>
							<span :class="{tab:true, active: alarmTab == 'access'}" @click="switchAlarmTab('access')">人员进出记录</span>
						</div>
					</div>
					<!-- 重点告警列表 -->
					<div class="alarm-list-wrapper" v-if="alarmTab == 'alarm'" @mouseenter="pauseAlarmScroll" @mouseleave="resumeAlarmScroll">
						<div class="alarm-list" ref="alarmList"
							:style="{ transform: `translateY(-${alarmScrollOffset}px)`, transition: alarmScrollTransition }">
							<div :class="{'alarm-item':true,'red breath-danger marquee-box marquee-danger':item.warnLevel== 0,
							'yellow breath-yellow marquee-box marquee-warning':item.warnLevel== 1,'orange breath-orange marquee-box marquee-orange':item.warnLevel== 2}"
								v-for="(item, idx) of displayAlarmList" :key="(item.id || item.warnId || 'a') + '_' + idx">
								<div class="icon-box">
									<img class="icon" v-if="item.warnLevel == 0" src="@/assets/yqzl (1).png" alt="" />
									<img class="icon" v-else-if="item.warnLevel == 1" src="@/assets/yqzl (5).png" alt="" />
									<img class="icon" v-else src="@/assets/yqzl (6).png" alt="" />
									<div class="icon-text">{{item.warnLevelName}}</div>
								</div>
								<div class="alarm-content">
									<div class="alarm-title">{{item.warnName}}</div>
									<div class="alarm-desc">{{item.warnContent}}</div>
								</div>
								<!-- <div class="alarm-time">{{item.warnTime}}</div> -->
								<div class="handle-btn" @click="deal_warn(item)">一键处理</div>
							</div>
						</div>
					</div>
					<!-- 人员进出记录列表（静态假数据，后期换正式接口） -->
					<div class="access-list-wrapper" v-else>
						<div class="access-item" v-for="(item, idx) in accessRecords" :key="item.recordId || idx" @click="openAccessDetail(item)">
							<div class="access-icon" :class="item.direction == 'IN' ? 'in' : 'out'">{{ item.directionName }}</div>
							<div class="access-content">
								<div class="access-title">
									<span class="name">{{ item.personName }}</span>
									<span class="tag">{{ item.identityTypeName }}</span>
									<span class="phone">{{ item.phone }}</span>
								</div>
								<div class="access-desc">
									<span>{{ item.accessTime }}</span>
									<span class="point">{{ item.accessPoint }}</span>
								</div>
							</div>
							<div class="access-result" :class="item.result == 'SUCCESS' ? 'success' : 'fail'">{{ item.resultName }}</div>
						</div>
					</div>
				</section>
				<!-- 视频监控 -->
				<section class="panel-section breath-panel  h3 marquee-box marquee-panel">
					<div class="section-header">
						<h2 class="section-title">视频监控</h2>
						<!-- <span class="more-btn">查看更多 ></span> -->
					</div>
					<div class="video-grid">
						<div class="video-item marquee-box marquee-panel" v-for="(item,index) in displayCameraList"
							:key="cameraGroupIndex + '_' + (item.deviceCode || index)">
							<div class="video-header">CAM 0{{index+1}}<br>{{item.deviceName}}</div>
							<div class="video-img" :ref="'jessibucaContainer_'+index"></div>
						</div>
					</div>
				</section>
				<!-- AI 问答助手 -->
				<section class="panel-section breath-panel  ai-section marquee-box marquee-panel">
					<div class="section-header">
						<h2 class="section-title">AI 问答助手</h2>
					</div>
					<div class="ai-content">
						<div class="ai-greeting">
							<img class="icon" src="@/assets/yqzl (4).png" alt="" />
							<div class="">
								<div class="text">您好，我是AI助理 </div>
								<div class="desc">
									可以为您解答园区管理相关问题
								</div>
							</div>
						</div>
						<div class="ai-quick" v-if="!aiAnswer && !aiLoading">
							<div class="quick-item" @click="askQuestion('园区设备运行情况如何？')">
								<img class="icon" src="@/assets/yqzl (20).png" alt="" />园区设备运行情况如何？
							</div>
							<div class="quick-item" @click="askQuestion('近24小时告警统计')">
								<img class="icon" src="@/assets/yqzl (20).png" alt="" />近24小时告警统计
							</div>
							<div class="quick-item" @click="askQuestion('2号楼浓度趋势分析')">
								<img class="icon" src="@/assets/yqzl (20).png" alt="" />2号楼浓度趋势分析
							</div>
							<div class="quick-item" @click="askQuestion('本月能耗报表生成')">
								<img class="icon" src="@/assets/yqzl (20).png" alt="" />本月能耗报表生成
							</div>
						</div>
						<div class="ai-answer" v-else>
							<div class="answer-loading" v-if="aiLoading && !aiAnswer">
								<span class="dot"></span><span class="dot"></span><span class="dot"></span>
								<span class="loading-text">AI 正在思考...</span>
							</div>
							<div class="answer-content" v-else>
								<div class="question-row">
									<span class="label">问：</span><span class="content">{{ aiQuestion }}</span>
								</div>
								<div class="answer-row">
									<span class="label">答：</span><span class="content">{{ aiAnswer }}</span>
								</div>
								<div class="answer-actions">
									<span class="reset-btn" @click="resetAi">重新提问</span>
								</div>
							</div>
						</div>
						<div class="ai-input">
							<input type="text" placeholder="请输入您的问题..." class="input-box"
								v-model="aiQuestionInput" @keyup.enter="sendQuestion" :disabled="aiLoading" />
							<img class="icon" src="@/assets/yqzl (3).png" alt="" @click="sendQuestion" style="cursor:pointer;" />
						</div>
					</div>
				</section>
			</aside>
		</main>

		<!-- 一键处理弹窗 -->
		<div class="handle-modal" v-show="showModal" @click.self="closeModal">
			<div class="modal-box">
				<div class="modal-header">
					<div class="status">紧急/ACTION</div>
					<div class="title">核心网关通信中断</div>
				</div>
				<img class="close" @click="closeModal" src="@/assets/close.png" alt="" />
				<div class="modal-body">
					<div class="form-item">
						<div class="label">告警来源：</div>
						<div class="text">3号核心网关/中心机房</div>
					</div>
					<div class="form-item">
						<div class="label">责任角色：</div>
						<div class="text">网络运维值班组</div>
					</div>
					<div class="form-item">
						<div class="label">处置时限：</div>
						<div class="text">10分钟内恢复主链路或切换备用链路</div>
					</div>
					<div class="form-item">
						<div class="label">STEP 01：</div>
						<div class="text">远程登录核心交换机检查端口状态</div>
					</div>
					<div class="form-item">
						<div class="label">STEP 02：</div>
						<div class="text">切换备用网关链路并观察3分钟</div>
					</div>
					<div class="form-item">
						<div class="label">STEP 03：</div>
						<div class="text">通知机房值守现场复核电源、光模块和跳线</div>
					</div>
				</div>
				<div class="modal-footer" @click="submitHandle">
					我已确认并开始处置
				</div>
			</div>
		</div>

		<!-- 人员进出记录详情弹窗（Element UI） -->
		<el-dialog  :visible.sync="accessDetailVisible" width="2.5rem" custom-class="access-detail-dialog"
			:close-on-click-modal="false" append-to-body>
			<div class="dialog-title">人员进出记录详情</div>
			<el-descriptions :column="2" border size="small">
				<el-descriptions-item label="姓名">{{ accessDetailData.personName }}</el-descriptions-item>
				<el-descriptions-item label="身份类型">{{ accessDetailData.identityTypeName }}</el-descriptions-item>
				<el-descriptions-item label="进出方向">{{ accessDetailData.directionName }}</el-descriptions-item>
				<el-descriptions-item label="通行结果">{{ accessDetailData.resultName }}</el-descriptions-item>
				<el-descriptions-item label="通行时间" :span="2">{{ accessDetailData.accessTime }}</el-descriptions-item>
				<el-descriptions-item label="进出点位" :span="2">{{ accessDetailData.accessPoint }}</el-descriptions-item>
				<el-descriptions-item label="手机号" :span="2">{{ accessDetailData.phone }}</el-descriptions-item>
				<el-descriptions-item label="所属公司" :span="2">{{ accessDetailData.companyName }}</el-descriptions-item>
				<el-descriptions-item label="证件类型">{{ accessDetailData.certificateType }}</el-descriptions-item>
				<el-descriptions-item label="证件号码">{{ accessDetailData.certificateNo }}</el-descriptions-item>
			</el-descriptions>
			<div class="dialog-btns">
				<el-button type="primary" size="small" @click="accessDetailVisible = false">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import wsService from '@/utils/websocketService'
	import { getScreenScale } from '@/utils/rem'
	export default {
		name: 'SmartParkDashboard',
		data() {
			return {
				showModal: false,
				form: {
					result: ''
				},
				dateKey: 'day',
				dateData: [{
						key: 'day',
						label: '日'
					},
					{
						key: 'week',
						label: '周'
					},
					{
						key: 'month',
						label: '月'
					},
				],
				pageSize: 50,
				pageNumber: 1,
				page_warn_listData: [],
				// 重点告警 / 人员进出记录 标签切换
				alarmTab: 'alarm', // alarm=重点告警 access=人员进出记录
				// 人员进出记录（静态假数据，后期换正式接口）
				accessRecords: [{
					recordId: 'access-demo-0001',
					accessTime: '2026-08-21 08:42:16',
					direction: 'IN',
					directionName: '进入',
					personName: '张伟',
					phone: '138****2468',
					identityType: 'STAFF',
					identityTypeName: '园区员工',
					companyName: '深圳市示例科技有限公司',
					certificateType: '工牌',
					certificateNo: 'YG20260821001',
					accessPoint: '园区东门',
					result: 'SUCCESS',
					resultName: '通行成功'
				}, {
					recordId: 'access-demo-0002',
					accessTime: '2026-08-21 09:05:33',
					direction: 'OUT',
					directionName: '离开',
					personName: '李娜',
					phone: '139****5172',
					identityType: 'VISITOR',
					identityTypeName: '访客',
					companyName: '深圳市示例设备有限公司',
					certificateType: '访客码',
					certificateNo: 'VIS20260821018',
					accessPoint: '园区北门',
					result: 'SUCCESS',
					resultName: '通行成功'
				}],
				camera_listData: [],
				// 人员进出记录详情弹窗
				accessDetailVisible: false,
				accessDetailData: {},
				jessibucaPlayers: [],
				jessibucaLoaded: false,
				// AI 问答助手
				aiQuestionInput: '',
				aiQuestion: '',
				aiAnswer: '',
				aiLoading: false,
				aiConversationId: null, // 会话 ID，start/done 事件返回，多轮对话复用
				aiAbortController: null, // 中断 SSE 请求用
			// 重点告警滚动播报
			alarmScrollOffset: 0,
			alarmScrollTransition: 'transform 0.6s ease',
			alarmScrollTimer: null,
			alarmScrollPaused: false,
			alarmItemHeight: 59, // 默认值，实际运行时从 DOM 动态测量（rem 适配后真实高度会变）
				// 视频监控轮播
				cameraGroupIndex: 0,
				cameraCarouselTimer: null
			}
		},
		computed: {
			// 告警滚动列表 - 数据 > 3 时复制一份用于无缝衔接
			displayAlarmList() {
				const list = this.page_warn_listData || []
				if (list.length <= 3) return list
				return [...list, ...list]
			},
			// 视频轮播：当前展示的 4 个摄像头
			displayCameraList() {
				const all = this.camera_listData || []
				if (all.length <= 4) return all.slice(0, 4)
				const start = (this.cameraGroupIndex * 4) % all.length
				const result = []
				for (let i = 0; i < 4; i++) {
					result.push(all[(start + i) % all.length])
				}
				return result
			},
			// 总分组数
			cameraGroupCount() {
				const all = this.camera_listData || []
				return Math.max(1, Math.ceil(all.length / 4))
			}
		},
		mounted() {
			this.initTrendChart()
			this.page_warn_list()
			this.loadJessibuca().then(() => {
				this.camera_list()
			}).catch(err => {
				console.error('加载jessibuca失败：', err)
				this.camera_list()
			})
			// 初始化告警 WebSocket
			wsService.initWarnWs(this.handleWarnMessage)
			// 启动告警滚动播报
			this.startAlarmScroll()
			// 窗口尺寸变化时重新测量 item 高度并重置滚动（rem 适配后高度会变）
			this._onResize = this._debounce(() => {
				this.alarmItemHeight = this.measureAlarmItemHeight()
				this.alarmScrollOffset = 0
			}, 300)
			window.addEventListener('resize', this._onResize)
		},
		beforeDestroy() {
			this.destroyAllPlayers()
			wsService.unsubscribeWarn(this.handleWarnMessage)
			this.stopAlarmScroll()
			this.stopCameraCarousel()
			// 中断未完成的 AI 流式请求
			if (this.aiAbortController) {
				this.aiAbortController.abort()
				this.aiAbortController = null
			}
			if (this._onResize) {
				window.removeEventListener('resize', this._onResize)
			}
		},
		methods: {
			loadJessibuca() {
				return new Promise((resolve, reject) => {
					if (window.Jessibuca) {
						this.jessibucaLoaded = true
						resolve()
						return
					}
					const script = document.createElement('script')
					script.src = '/static/jessibuca/jessibuca.js'
					script.onload = () => {
						this.jessibucaLoaded = true
						resolve()
					}
					script.onerror = (err) => {
						reject(err)
					}
					document.head.appendChild(script)
				})
			},
			initVideoPlayers() {
				this.$nextTick(() => {
					console.log('[jessibuca] 开始初始化播放器, window.Jessibuca:', !!window.Jessibuca, '摄像头数量:', this
						.camera_listData.length)
					if (!window.Jessibuca) {
						console.error('[jessibuca] window.Jessibuca 未加载')
						return
					}
					if (!this.camera_listData.length) {
						console.warn('[jessibuca] 摄像头列表为空')
						return
					}

					// 1. 先销毁所有旧播放器
					this.destroyAllPlayers()

					// 2. 等待 DOM 更新后串行初始化
					this.$nextTick(() => {
						setTimeout(() => {
							this.initPlayersSequentially(0)
						}, 200)
					})
				})
			},
			// 串行初始化播放器，避免并发资源竞争
			initPlayersSequentially(index) {
				const list = this.displayCameraList || []
				if (index >= 4 || index >= list.length) {
					console.log('[initPlayersSequentially] ✅ 播放器全部初始化完成')
					return
				}

				const item = list[index]
				const containerRef = 'jessibucaContainer_' + index
				const containerArr = this.$refs[containerRef]
				const container = Array.isArray(containerArr) ? containerArr[0] : containerArr

				// console.log(`[jessibuca] ===== 摄像头 ${index} =====`)
				// console.log(`  名称:`, item.deviceName)
				// console.log(`  流地址:`, item.flvStreamUrl)
				// console.log(`  容器存在:`, !!container)

				if (!container) {
					console.error(`[jessibuca] ❌ 摄像头${index} 容器未找到`)
					// 跳过这个，初始化下一个
					setTimeout(() => this.initPlayersSequentially(index + 1), 100)
					return
				}
				if (!item.flvStreamUrl) {
					console.warn(`[jessibuca] ⚠️ 摄像头${index} 缺少流地址`)
					// 跳过这个，初始化下一个
					setTimeout(() => this.initPlayersSequentially(index + 1), 100)
					return
				}

				try {
					const decoderUrl = window.location.origin + process.env.BASE_URL +
						'static/jessibuca/decoder.js'
					console.log(`[jessibuca] 解码器地址:`, decoderUrl)
					const player = new window.Jessibuca({
						container: container,
						decoder: decoderUrl,
						videoBuffer: 0.2,
						isResize: false,
						text: "",
						loadingText: "加载中...",
						useMSE: true,
						useWCS: false,
						autoWasm: true,
						forceNoOffscreen: false,
						isNotMute: false,
						timeout: 10,
						hasAudio: false,
						operateBtns: {
							fullscreen: false,
							screenshot: false,
							play: false,
							audio: false,
						},
						controlAutoHide: true,
						debug: false,
					})
					player.on('play', () => {
						console.log(`[jessibuca] ✅ 播放器 ${index} 开始播放`)
					})
					player.on('error', (error) => {
						console.error(`[jessibuca] ❌ 播放器 ${index} 错误:`, error)
					})
					player.on('load', () => {
						console.log(`[jessibuca]  播放器 ${index} 已加载`)
					})
					player.on('timeout', () => {
						console.error(`[jessibuca] ⏱️ 播放器 ${index} 超时`)
					})
					console.log(`[jessibuca]  播放器 ${index} 开始播放:`, item.flvStreamUrl)
					player.play(item.flvStreamUrl)
					this.jessibucaPlayers.push(player)
					console.log(`[jessibuca] ✅ 播放器 ${index} 初始化完成`)

					// 500ms 后初始化下一个播放器
					setTimeout(() => {
						this.initPlayersSequentially(index + 1)
					}, 500)
				} catch (err) {
					console.error(`[jessibuca] ❌ 初始化播放器 ${index} 失败:`, err)
					// 出错也继续初始化下一个
					setTimeout(() => {
						this.initPlayersSequentially(index + 1)
					}, 100)
				}
			},
			destroyAllPlayers() {
				this.jessibucaPlayers.forEach(player => {
					if (player && player.destroy) {
						try {
							player.destroy()
						} catch (err) {
							console.error('销毁播放器失败:', err)
						}
					}
				})
				this.jessibucaPlayers = []
				// 清空所有视频容器内残留的 DOM（canvas/video）
				for (let i = 0; i < 4; i++) {
					const containerRef = 'jessibucaContainer_' + i
					const containerArr = this.$refs[containerRef]
					const container = Array.isArray(containerArr) ? containerArr[0] : containerArr
					if (container) {
						container.innerHTML = ''
					}
				}
			},
			deal_warn(item) {
				this.$http.post(this.$api.BASE_URL_Category.deal_warn, {
					warnId: item.warnId,
					warnDealAction: "2",
				}).then(res => {
					this.$message.success(res.msg);
					this.page_warn_list()
				})
			},
			camera_list() {
				console.log('[camera_list] 开始请求摄像头列表接口')
				this.$http.get(this.$api.BASE_URL_Category.camera_list, {
					pageNumber: 1,
					pageSize: 1000
				}).then(res => {
					console.log('[camera_list] 接口返回数据:', res)
					console.log('[camera_list] res.data.data:', res.data.data)
					const allList = res.data.data || []
					// 过滤出有 flvStreamUrl 的摄像头优先展示
					const validList = allList.filter(item => item.flvStreamUrl)
					const invalidList = allList.filter(item => !item.flvStreamUrl)
					this.camera_listData = [...validList, ...invalidList]
					console.log('[camera_list] 有效流数量:', validList.length, '总数:', allList.length)
					console.log('[camera_list] this.camera_listData:', this.camera_listData)
					this.cameraGroupIndex = 0
					this.initVideoPlayers()
					// 启动 1 分钟自动轮播（仅在数据多于 4 个时）
					this.startCameraCarousel()
				}).catch(err => {
					console.error('[camera_list] 接口请求失败:', err)
				})
			},
			// 启动视频自动轮播（间隔 1 分钟）
			startCameraCarousel() {
				this.stopCameraCarousel()
				console.log('[视频轮播] 尝试启动 - 摄像头总数:', this.camera_listData.length, '总分组:', this.cameraGroupCount)
				if (this.camera_listData.length <= 4) {
					console.log('[视频轮播] 摄像头数量不足 4 个以上，不启动轮播')
					return
				}
				console.log('[视频轮播] 已启动，间隔 60 秒')
				this.cameraCarouselTimer = setInterval(() => {
					this.cameraGroupIndex = (this.cameraGroupIndex + 1) % this.cameraGroupCount
					console.log('[视频轮播] 切换到第', this.cameraGroupIndex + 1, '组 / 共', this.cameraGroupCount, '组', '新组数据:', this.displayCameraList.map(c => c.deviceName))
					// 切换组后重新初始化播放器
					this.initVideoPlayers()
				}, 60 * 1000)
			},
			// 停止视频轮播
			stopCameraCarousel() {
				if (this.cameraCarouselTimer) {
					clearInterval(this.cameraCarouselTimer)
					this.cameraCarouselTimer = null
				}
			},
			// 测量单个告警项的真实高度（含 margin，rem 适配后实际像素会随屏幕变化）
			measureAlarmItemHeight() {
				const wrapper = this.$refs.alarmList
				if (!wrapper) return this.alarmItemHeight
				const item = wrapper.querySelector('.alarm-item')
				if (!item) return this.alarmItemHeight
				// offsetHeight 不含 margin，需手动加 margin-bottom
				const style = getComputedStyle(item)
				const marginBottom = parseFloat(style.marginBottom) || 0
				const h = item.offsetHeight + marginBottom
				return h > 0 ? h : this.alarmItemHeight
			},
			// 简易防抖
			_debounce(fn, delay) {
				let timer = null
				return (...args) => {
					if (timer) clearTimeout(timer)
					timer = setTimeout(() => fn.apply(this, args), delay)
				}
			},
			// 启动告警滚动播报（每 3 秒向上滚动一条）
			startAlarmScroll() {
				this.stopAlarmScroll()
				// 先从 DOM 测量真实高度，避免 rem 适配后写死值不匹配
				this.alarmItemHeight = this.measureAlarmItemHeight()
				this.alarmScrollTimer = setInterval(() => {
					if (this.alarmScrollPaused) return
					const list = this.page_warn_listData || []
					if (list.length <= 3) {
						this.alarmScrollOffset = 0
						return
					}
					// 平滑向上滚动一条
					this.alarmScrollTransition = 'transform 0.6s ease'
					this.alarmScrollOffset += this.alarmItemHeight
					// 当滚动到第一份数据末尾时，瞬时回到起点（无缝衔接）
					if (this.alarmScrollOffset >= list.length * this.alarmItemHeight) {
						setTimeout(() => {
							this.alarmScrollTransition = 'none'
							this.alarmScrollOffset = 0
							// 强制重绘后恢复过渡
							this.$nextTick(() => {
								setTimeout(() => {
									this.alarmScrollTransition = 'transform 0.6s ease'
								}, 50)
							})
						}, 650)
					}
				}, 3000)
			},
			// 停止告警滚动
			stopAlarmScroll() {
				if (this.alarmScrollTimer) {
					clearInterval(this.alarmScrollTimer)
					this.alarmScrollTimer = null
				}
			},
			// 鼠标悬停暂停滚动
			pauseAlarmScroll() {
				this.alarmScrollPaused = true
			},
			// 鼠标离开恢复滚动
			resumeAlarmScroll() {
				this.alarmScrollPaused = false
			},
			page_warn_list() {
				this.$http.get(this.$api.BASE_URL_Category.page_warn_list, {
					pageNumber: this.pageNumber,
					pageSize: this.pageSize
				}).then(res => {
					const data = res.data || {}
					this.page_warn_listData = data.data || []
					// 数据更新后重置滚动位置
					this.alarmScrollOffset = 0
				}).catch(err => {
					console.error('获取告警列表失败：', err)
				})
			},
			// AI 问答 - 快捷问题点击
			askQuestion(question) {
				if (this.aiLoading) return
				this.aiQuestionInput = question
				this.sendQuestion()
			},
			// AI 问答 - 发送问题（SSE 流式，接口 /ai/assistant/chat/stream）
			async sendQuestion() {
				const question = (this.aiQuestionInput || '').trim()
				if (!question) {
					this.$message && this.$message.warning('请输入问题')
					return
				}
				if (this.aiLoading) return

				this.aiQuestion = question
				this.aiAnswer = ''
				this.aiLoading = true
				this.aiQuestionInput = ''

				// 中断上一次未完成的请求
				if (this.aiAbortController) this.aiAbortController.abort()
				const controller = new AbortController()
				this.aiAbortController = controller
				// 60s 兜底超时，避免流卡死
				const timeoutTimer = setTimeout(() => controller.abort(), 60 * 1000)

				// 构造认证头（与 request.js 保持一致，Authorization 按文档补充 Bearer 前缀）
				let authorization = localStorage.getItem('authorization') || ''
				if (authorization && !/^Bearer\s/i.test(authorization)) {
					authorization = 'Bearer ' + authorization
				}

				const requestKey = 'park-ai-' + Date.now() + '-' + Math.random().toString(36).slice(2, 6)
				const payload = {
					comProjectId: '604469234560770048',
					conversationId: this.aiConversationId,
					requestKey: requestKey,
					question: question
				}

				try {
					const response = await fetch(this.$api.BASE_URL_Category.ai_chat_stream, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Accept': 'text/event-stream',
							'company-code': '9',
							'token': localStorage.getItem('token') || '',
							'Authorization': authorization
						},
						body: JSON.stringify(payload),
						signal: controller.signal
					})

					if (!response.ok) {
						throw new Error('HTTP ' + response.status)
					}
					if (!response.body) {
						throw new Error('当前浏览器不支持流式读取')
					}

					const reader = response.body.getReader()
					const decoder = new TextDecoder('utf-8')
					let buffer = ''

					while (true) {
						const { done, value } = await reader.read()
						if (done) break
						buffer += decoder.decode(value, { stream: true })
						// 按空行分隔 SSE 事件块
						let idx
						while ((idx = buffer.indexOf('\n\n')) !== -1) {
							const chunk = buffer.slice(0, idx)
							buffer = buffer.slice(idx + 2)
							this.handleSSEEvent(chunk)
						}
					}
				} catch (err) {
					if (err && err.name === 'AbortError') {
						console.log('[AI问答] 请求已中断')
					} else {
						console.error('[AI问答] 请求失败:', err)
						this.aiAnswer = '抱歉，AI 助手暂时无法回答，请稍后再试。'
					}
				} finally {
					clearTimeout(timeoutTimer)
					this.aiLoading = false
					this.aiAbortController = null
				}
			},
			// 解析单个 SSE 事件块（event: / data: 行）
			handleSSEEvent(chunk) {
				let eventType = 'message'
				const dataLines = []
				const lines = chunk.split('\n')
				for (const line of lines) {
					if (line.startsWith('event:')) {
						eventType = line.slice(6).trim()
					} else if (line.startsWith('data:')) {
						dataLines.push(line.slice(5).trim())
					}
				}
				if (!dataLines.length) return
				const raw = dataLines.join('\n')
				if (raw === '[DONE]') return
				let data = raw
				try {
					data = JSON.parse(raw)
				} catch (e) {
					// 非 JSON 数据按原字符串处理
				}
				this.handleSSEData(eventType, data)
			},
			// 按事件类型分发处理
			handleSSEData(eventType, data) {
				const getCid = () => {
					if (data && data.conversationId) return data.conversationId
					if (data && data.data && data.data.conversationId) return data.data.conversationId
					return null
				}
				switch (eventType) {
					case 'start':
						// 返回或创建会话 ID
						{
							const cid = getCid()
							if (cid) this.aiConversationId = cid
						}
						break
					case 'sources':
						// 回答引用来源，当前 UI 不展示
						console.log('[AI问答] 引用来源:', data)
						break
					case 'artifacts':
						// 结构化指标/表格，当前 UI 不展示
						console.log('[AI问答] 结构化产物:', data)
						break
					case 'delta':
						// 增量文本，按顺序拼接
						{
							const text = (data && data.data && data.data.text) || (data && data.text) || ''
							if (text) this.aiAnswer += text
						}
						break
					case 'done':
						// 结束，保存会话 ID
						{
							const cid = getCid()
							if (cid) this.aiConversationId = cid
						}
						this.aiLoading = false
						break
					case 'error':
						// 可展示的错误信息
						{
							const msg = (data && (data.message || data.msg || data.error)) || 'AI 助手回答失败，请稍后再试。'
							console.error('[AI问答] 返回错误:', data)
							if (!this.aiAnswer) this.aiAnswer = msg
						}
						this.aiLoading = false
						break
					default:
						console.log('[AI问答] 未知事件:', eventType, data)
						break
				}
			},
			// AI 问答 - 重置
			resetAi() {
				if (this.aiAbortController) {
					this.aiAbortController.abort()
					this.aiAbortController = null
				}
				this.aiQuestion = ''
				this.aiAnswer = ''
				this.aiQuestionInput = ''
				this.aiLoading = false
				this.aiConversationId = null
			},
			dateClick(key) {
				this.dateKey = key;
				this.initTrendChart()
			},
			// 重点告警 / 人员进出记录 标签切换
			switchAlarmTab(tab) {
				this.alarmTab = tab
			},
			// 点击人员进出记录条目：弹详情 + 通知父组件切到园区大门视角
			openAccessDetail(item) {
				this.accessDetailData = item || {}
				this.accessDetailVisible = true
				this.$emit('accessItemClick', item)
			},
			// 事件趋势多线图
			initTrendChart() {
				this.$http.get(this.$api.BASE_URL_Category.level_trend, {
					dateType: this.dateKey
				}).then(res => {
					var jj = []
					var zy = []
					var gz = []
					res.data.series.map(item => {
						if (item.warnLevel == 0) {
							jj = item.counts
						} else if (item.warnLevel == 1) {
							zy = item.counts
						} else {
							gz = item.counts
						}
					})
					const scale = getScreenScale();
					const myChart = this.$echarts.init(this.$refs.trendChart)
					const option = {
						tooltip: {
							trigger: 'axis',
							textStyle: {
								fontSize: Math.round(14 * scale)
							}
						},
						legend: {
							show: false
						},
						grid: {
							// 四向边距随屏幕等比缩放（与字号同乘 scale），
							// 任何分辨率下布局比例一致，标签不会被裁切/溢出
							top: Math.round(8 * scale),
							left: Math.round(55 * scale),
							right: Math.round(10 * scale),
							bottom: Math.round(65 * scale),
							containLabel: false
						},
						xAxis: {
							type: 'category',
							boundaryGap: false,
							data: res.data.times,
							axisLine: {
								lineStyle: {
									color: '#333'
								}
							},
							axisLabel: {
								interval: 0,
								color: '#888',
								fontSize: Math.round(12 * scale),
								rotate: 30,
								margin: 10
							},
							axisPointer: {
								type: 'shadow'
							}
						},
						yAxis: {
							type: 'value',
							min: 0,
							axisLine: {
								show: false
							},
							splitLine: {
								lineStyle: {
									color: '#333'
								}
							},
							axisLabel: {
								color: '#888',
								fontSize: Math.round(14 * scale),
								margin: 8
							}
						},
						series: [{
								name: '紧急',
								type: 'line',
								smooth: true,
								data: jj,
								itemStyle: {
									color: '#ff4d4f'
								},
								lineStyle: {
									color: '#ff4d4f',
									width: 2
								},
								areaStyle: {
									color: 'rgba(255,77,79,0.2)'
								}
							},
							{
								name: '重要',
								type: 'line',
								smooth: true,
								data: zy,
								itemStyle: {
									color: '#ffc107'
								},
								lineStyle: {
									color: '#ffc107',
									width: 2
								},
								areaStyle: {
									color: 'rgba(255,193,7,0.2)'
								}
							},
							{
								name: '关注',
								type: 'line',
								smooth: true,
								data: gz,
								itemStyle: {
									color: '#ff9800'
								},
								lineStyle: {
									color: '#ff9800',
									width: 2
								},
								areaStyle: {
									color: 'rgba(255,152,0,0.2)'
								}
							}
						]
					}
					myChart.setOption(option)
					window.addEventListener('resize', () => myChart.resize())
				}).catch(err => {
					console.error('获取趋势图数据失败：', err)
				})
			},
			// 打开处理弹窗
			handleAlarm() {
				this.showModal = true
			},
			// 关闭弹窗
			closeModal() {
				this.showModal = false
			},
			// 提交处理
			submitHandle() {
				this.closeModal()
			},
			// 处理告警 WebSocket 消息
			handleWarnMessage(message) {
				console.log('[parkOverviewRight] 收到告警推送:', message)
				// 刷新告警列表
				this.page_warn_list()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.dashboard-container {
		width: 420px;
		position: absolute;
		top: 90px;
		right: 10px;
		z-index: 2;
		height: 100%;
		color: #B3C8DC;
		font-size: 14px;

		.main-content {
			.right-panel {
				width: 100%;
				display: flex;
				flex-direction: column;
				gap: 10px;
			}
		}

		.h1 {
			height: 206px;
		}

		.h2 {
			height: 227px;
		}

		.h3 {
			height: 280px;
		}

		.panel-section {
			overflow: hidden;
			background: rgba(#091724, 0.8);
			// border: 1px solid #4578A8;
			border-radius: 12px;
			padding: 12px;

			.section-title {
				font-size: 16px;
				font-weight: bold;
			}

			.section-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 15px;

				.more-btn {
					color: #B3C8DC;
					font-size: 12px;
				}

				.chart-tabs {
					display: flex;
					gap: 10px;

					.tab {
						cursor: pointer;
						padding: 4px 8px;
						border-radius: 4px;
						color: #ccc;
						font-size: 12px;

						&.active {
							background: #4A98F7;
							color: #B3C8DC;
						}
					}
				}

				.legend {
					display: flex;
					gap: 10px;
					font-size: 10px;
					color: #ccc;

					.legend-item {
						display: flex;
						align-items: center;
						gap: 4px;

						.dot {
							width: 8px;
							height: 8px;
							border-radius: 50%;

							&.red {
								background: #ff4d4f;
							}

							&.yellow {
								background: #ffc107;
							}

							&.orange {
								background: #ff9800;
							}
						}
					}
				}
			}

			.echarts-trend {
				width: 100%;
				height: 190px;
			}

			.alarm-list-wrapper {
				height: 177px;
				overflow: hidden;
				position: relative;
			}

			.alarm-list {
				will-change: transform;
				.alarm-item {
					width: 100%;
					height: 48px;
					display: flex;
					align-items: center;
					gap: 10px;
					padding: 6px 10px;
					border-radius: 8px;
					margin-bottom: 11px;
					font-size: 12px;

					.icon-box {
						display: flex;
						align-items: center;
						margin-right: 10px;

						.icon {
							width: 15px;
							height: 15px;
							margin-right: 5px;
							margin-top: -3px;
						}

						.icon-text {
							font-weight: 500;
							font-size: 10px;
							color: #FF4A4A;
						}
					}

					.handle-btn {
						cursor: pointer;
						width: 50px;
						height: 20px;
						text-align: center;
						line-height: 16px;
						font-size: 10px;
						color: #B3C8DC;
						border-radius: 4px 4px 4px 4px;
						background: #582A26;
						border: 1px solid #FF5749;
					}

					&.red {
						border: 1px solid #FF4A4A;
						background: linear-gradient(0deg, rgba(255, 74, 74, 0.5) 0%, rgba(255, 86, 74, 0) 100%);

						.icon-text {
							color: #FF4A4A;
						}
					}

					&.yellow {
						border: 1px solid #FFBE4A;
						background: linear-gradient(0deg, rgba(255, 190, 74, 0.5) 0%, rgba(255, 190, 74, 0) 100%);

						.icon-text {
							color: #FFBE4A;
						}

						.handle-btn {
							background: #4B391A;
							border: 1px solid #FFBE4A;
						}
					}

					&.orange {
						border: 1px solid #DA7E40;
						background: linear-gradient(0deg, rgba(218, 126, 64, 0.5) 0%, rgba(218, 126, 64, 0) 100%);

						.icon-text {
							color: #DA7E40;
						}

						.handle-btn {
							background: #2B1B11;
							border: 1px solid #DA7E40;
						}
					}

					.alarm-content {
						flex: 1;

						.alarm-title {
							color: #B3C8DC;
							font-weight: bold;
							font-size: 12px;
							margin-bottom: 4px;
						}

						.alarm-desc {
							font-size: 10px;
							color: #B3C8DC;
						}
					}

					.alarm-time {
						font-size: 10px;
						color: #B3C8DC;
					}
				}
			}

			// 人员进出记录列表
			.access-list-wrapper {
				height: 177px;
				overflow-y: auto;

				.access-item {
					width: 100%;
					display: flex;
					align-items: center;
					gap: 10px;
					padding: 10px;
					border-radius: 8px;
					margin-bottom: 11px;
					background: rgba(74, 152, 247, 0.08);
					border: 1px solid rgba(69, 120, 168, 0.5);
					box-sizing: border-box;
					cursor: pointer;
					transition: border-color 0.2s;

					&:hover {
						border-color: #36d1ff;
					}

					.access-icon {
						flex-shrink: 0;
						width: 34px;
						height: 34px;
						line-height: 34px;
						text-align: center;
						border-radius: 50%;
						font-size: 12px;
						font-weight: bold;

						&.in {
							color: #36d1ff;
							border: 1px solid #36d1ff;
							background: rgba(54, 209, 255, 0.12);
						}

						&.out {
							color: #FFBE4A;
							border: 1px solid #FFBE4A;
							background: rgba(255, 190, 74, 0.12);
						}
					}

					.access-content {
						flex: 1;
						min-width: 0;

						.access-title {
							display: flex;
							align-items: center;
							gap: 8px;
							margin-bottom: 4px;

							.name {
								color: #B3C8DC;
								font-weight: bold;
								font-size: 12px;
							}

							.tag {
								font-size: 10px;
								color: #36d1ff;
								border: 1px solid rgba(54, 209, 255, 0.5);
								border-radius: 3px;
								padding: 0 4px;
								line-height: 16px;
							}

							.phone {
								font-size: 10px;
								color: #7B93A8;
							}
						}

						.access-desc {
							display: flex;
							align-items: center;
							gap: 10px;
							font-size: 10px;
							color: #7B93A8;

							.point {
								color: #B3C8DC;
							}
						}
					}

					.access-result {
						flex-shrink: 0;
						font-size: 12px;
						font-weight: bold;

						&.success {
							color: #36d1ff;
						}

						&.fail {
							color: #FF4A4A;
						}
					}
				}
			}

			.video-grid {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				justify-content: space-between;
				overflow: hidden;
				gap: 15px;

				.video-item {
					width: 48%;
					height: 105px;
					border-radius: 10px;
					position: relative;
					overflow: hidden;
					border: 1px solid #4578A8;

					.video-header {
						width: 100%;
						position: absolute;
						top: 0px;
						left: 0px;
						background: linear-gradient(90deg, #081724 0%, rgba(102, 102, 102, 0) 100%);
						padding: 4px 7px;
						font-size: 10px;
						z-index: 2;
						pointer-events: none;
					}

					.video-img {
						width: 100%;
						height: 100%;
						border-radius: 10px;
						position: absolute;
						top: 0;
						left: 0;
						z-index: 1;
					}

					.video-img ::v-deep canvas,
					.video-img ::v-deep video {
						width: 100% !important;
						height: 100% !important;
						display: block !important;
						object-fit: cover;
					}
				}
			}
		}

		.ai-section {
			height: 235px;

			.ai-content {
				width: 401px;
				height: 180px;
				padding: 10px 10px 2px;
				margin: 10px auto;
				background: rgba(9, 23, 36, 0.9);
				border-radius: 10px 10px 10px 10px;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				// border: 1px solid #4578A8;

				.ai-greeting {
					flex-shrink: 0;
					display: flex;
					align-items: center;
					gap: 10px;
					margin-bottom: 4px;
					font-size: 12px;

					.icon {
						width: 34px;
						height: 34px;
					}

					.text {
						font-size: 14px;
						color: #7ABFFF;
						margin-bottom: 5px;
					}

					.desc {
						font-size: 10px;
						color: #B3C8DC;
					}
				}

				.ai-quick {
					flex-shrink: 0;
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					justify-content: space-between;
					gap: 10px;
					margin-bottom: 10px;

					.quick-item {
						cursor: pointer;
						display: flex;
						align-items: center;
						width: 180px;
						height: 28px;
						padding: 10px;
						background: rgba(9, 23, 36, 0.9);
						border-radius: 6px;
						border: 1px solid #4578A8;
						font-size: 10px;
						color: #B3C8DC;

						.icon {
							width: 8px;
							height: 8px;
							margin-right: 10px;
						}
					}
				}

				.ai-input {
					flex-shrink: 0;
					display: flex;
					flex-wrap: nowrap;
					gap: 8px;

					.input-box {
						width: 336px;
						height: 28px;
						background: rgba(9, 23, 36, 0.9);
						border-radius: 6px;
						border: 1px solid #4578A8;
						font-size: 10px;
						padding-left: 10px;
						color: #B3C8DC;

						&::placeholder {
							color: #B3C8DC;
						}

						&:disabled {
							opacity: 0.6;
							cursor: not-allowed;
						}
					}

					.icon {
						width: 28px;
						height: 28px;
					}
				}

				.ai-answer {
					flex: 1;
					min-height: 0;
					overflow-y: auto;
					margin-bottom: 8px;
					background: rgba(9, 23, 36, 0.6);
					border-radius: 8px;
					padding: 10px 12px;
					font-size: 12px;
					line-height: 1.6;
					color: #B3C8DC;

					.answer-loading {
						display: flex;
						align-items: center;
						gap: 6px;
						padding: 20px 0;
						justify-content: center;

						.dot {
							width: 6px;
							height: 6px;
							border-radius: 50%;
							background: #36d1ff;
							animation: aiDotBlink 1.2s infinite;

							&:nth-child(2) {
								animation-delay: 0.2s;
							}

							&:nth-child(3) {
								animation-delay: 0.4s;
							}
						}

						.loading-text {
							margin-left: 6px;
							color: #7ABFFF;
							font-size: 12px;
						}
					}

					.answer-content {
						position: relative;
						.question-row,
						.answer-row {
							display: flex;
							margin-bottom: 6px;
							word-break: break-all;

							.label {
								flex-shrink: 0;
								color: #36d1ff;
								font-weight: 500;
								margin-right: 4px;
							}

							.content {
								flex: 1;
								color: #B3C8DC;
							}
						}

						.answer-row .content {
							color: #cfe4f5;
						}

						.answer-actions {
							position: absolute;
							top: 0;
							right: 0;
							text-align: right;

							.reset-btn {
								display: inline-block;
								padding: 2px 10px;
								font-size: 11px;
								color: #36d1ff;
								border: 1px solid #36d1ff;
								border-radius: 4px;
								cursor: pointer;

								&:hover {
									background: rgba(54, 209, 255, 0.1);
								}
							}
						}
					}
				}

				@keyframes aiDotBlink {
					0%, 80%, 100% {
						opacity: 0.3;
						transform: scale(0.8);
					}
					40% {
						opacity: 1;
						transform: scale(1);
					}
				}
			}
		}

		// 弹窗样式
		.handle-modal {
			position: absolute;
			top: 217px;
			right: 430px;

			.modal-box {
				width: 420px;
				height: 467px;
				padding: 11px 16px;
				position: relative;
				background: rgba(9, 23, 36, 0.8);
				// border: 1px solid #4578A8;
				border-radius: 12px;
				color: #B3C8DC;
				overflow: hidden;

				.close {
					width: 24px;
					height: 24px;
					position: absolute;
					top: 10px;
					right: 10px;
					cursor: pointer;
				}

				.modal-header {
					margin-bottom: 16px;

					.status {
						font-weight: bold;
						font-size: 12px;
						color: #FF4A4A;
						margin-bottom: 8px;
					}

					.title {
						font-weight: 500;
						font-size: 16px;
						color: #B3C8DC;
					}
				}

				.modal-body {
					.form-item {
						width: 384px;
						height: 45px;
						padding: 5px 10px;
						background: rgba(9, 23, 36, 0.8);
						border-radius: 8px;
						// border: 1px solid #4578A8;
						margin-bottom: 12px;

						.label {
							font-size: 10px;
							color: #B3C8DC;
							margin-bottom: 5px;
						}

						.text {
							font-size: 14px;
							color: #B3C8DC;
						}

					}
				}

				.modal-footer {
					color: #B3C8DC;
					height: 48px;
					margin-top: 6px;
					font-weight: bold;
					line-height: 48px;
					text-align: center;
					font-size: 18px;
					background: #349DFF;
					border-radius: 14px 14px 14px 14px;
					cursor: pointer;
				}
			}
		}
	}
</style>

<style lang="scss">
	/* 人员进出记录详情弹窗：深色科技风（与模型设备弹框配色一致）；append-to-body 后 scoped 不生效 */
	.access-detail-dialog.el-dialog {
		background: linear-gradient(180deg, #0a1a2e 0%, #091724 100%);
		border: 1px solid #2C3D52;
		border-radius: 12px;
		box-shadow: 0 8px 40px rgba(0, 150, 255, 0.15);
		overflow: hidden;
	}

	.access-detail-dialog .el-dialog__header {
		padding: 0;
		background: linear-gradient(180deg, #0d2340 0%, #091724 100%);
		border-bottom: 1px solid #2C3D52;
	}

	.access-detail-dialog .el-dialog__headerbtn {
		top: 12px;
		right: 12px;
	}

	.access-detail-dialog .el-dialog__headerbtn .el-dialog__close {
		color: #B3C8DC;
	}

	.access-detail-dialog .el-dialog__body {
		padding: 14px 20px 16px;
		color: #B3C8DC;
	}

	.access-detail-dialog .dialog-title {
		font-size: 16px;
		font-weight: bold;
		color: #B3C8DC;
		padding-right: 30px;
		padding-bottom: 10px;
		margin-bottom: 14px;
		border-bottom: 1px solid #1a2e44;
	}

	.access-detail-dialog .el-descriptions {
		margin-bottom: 4px;
	}

	/* el-descriptions 深色表格（白色线条 → 深色边框） */
	.access-detail-dialog .el-descriptions__body {
		background-color: #091724;
		color: #B3C8DC;
	}

	.access-detail-dialog .el-descriptions .is-bordered .el-descriptions-item__cell {
		border-color: #2C3D52;
	}

	.access-detail-dialog .el-descriptions-item__label.is-bordered-label {
		background: #0d2340;
		color: #5a7a96;
	}

	.access-detail-dialog .el-descriptions-item__content {
		color: #B3C8DC;
	}

	.access-detail-dialog .dialog-btns {
		text-align: right;
		padding-top: 14px;
	}

	.access-detail-dialog .el-button--primary {
		background: #4A98F7;
		border-color: #4A98F7;
	}
</style>